import { render, staticRenderFns } from "./InvestmentsByGender.vue?vue&type=template&id=71975564&"
import script from "./InvestmentsByGender.vue?vue&type=script&lang=ts&"
export * from "./InvestmentsByGender.vue?vue&type=script&lang=ts&"
import style0 from "./InvestmentsByGender.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports